/* eslint-disable @next/next/no-img-element */
import ContinueButtons from 'components/enter/ContinueButtons';
import { EntryMethod, EntryMethodDetails } from 'components/enter/EntryMethod';
import { ASSET_PREFIX, colors } from 'utils/constants';
// @ts-ignore
import Subheading from 'components/Subheading';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { useUIStore } from 'hooks/stores/useUIStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import { ValueOf } from 'next/dist/shared/lib/constants';
import { useRouter } from 'next/router';
import { scrollToSection, sleep } from 'utils/common';
import { navigateToConfirmation } from 'utils/navigation';
import { BoostJackpotEnter } from '../boost-section/BoostJackpotEnter';
import NewPlanSelector from '../NewPlanSelector';
import { OrderSummaryMain } from '../order-summary/OrderSummaryMain';
import { PageState } from '../PageContent';
import { ChooseDrawDays } from './ChooseDrawDays';
import { ChooseNumbers } from './ChooseNumbers';
import { Nudges } from './Nudges';
import { getChooseYourPlanBoostValue } from 'utils/ab-test/abTests';

interface IConfigureTicketAndSubscription {
  id: string;
  setPageState: (state: ValueOf<typeof PageState>) => void;
}

const ConfigureTicketAndSubscription = observer(
  ({ id, setPageState }: IConfigureTicketAndSubscription) => {
    const { entryMethod, lines, discountBannerText, handleContinueToPayment } =
      useEnterStore();
    const { currentUser, eligibleForIntroOffer, updateCurrentUser } =
      useUserStore();
    const router = useRouter();
    const { displayToast } = useUIStore();
    const chooseYourPlanVariant = getChooseYourPlanBoostValue();

    return (
      <div
        id={id}
        className={`configureTicketAndSubscription grid gap-8 fullWidth`}
      >
        {EntryMethodDetails[entryMethod].withFirstEntryFreeBanner &&
          eligibleForIntroOffer && (
            <img
              src={`${ASSET_PREFIX}/images/landing/diagonal-banner-${
                discountBannerText
              }.png`}
              className={`introductoryOfferBanner desktop-banner`}
              alt={discountBannerText || undefined}
            />
          )}

        {entryMethod !== EntryMethod.PremiumSubscription ? (
          <div className="flex flex-col justify-center">
            <Subheading
              style={{ fontSize: 35 }}
              className="noMargin normal-case"
              underlineColor={
                EntryMethodDetails[entryMethod].underlineGlowColor
              }
            >
              Enter Now
            </Subheading>
          </div>
        ) : (
          <div className="flex flex-col justify-center">
            <>
              <p
                style={{
                  fontSize: 20,
                  fontFamily: 'Montserrat-ExtraBold, Montserrat !important',
                }}
                className={
                  'big-font-desktop normal-case spacing-normal tracking-normal font-extrabold text-center'
                }
              >
                Select your
              </p>
              <p
                style={{
                  fontSize: 20,
                  fontFamily: 'Montserrat-ExtraBold, Montserrat !important',
                }}
                className={
                  '-mt-7 big-font-desktop normal-case spacing-normal tracking-normal font-extrabold text-center'
                }
              >
                weekly entries
              </p>
            </>
          </div>
        )}

        <NewPlanSelector additionalClassName="orderBox withoutPadding" />

        {entryMethod != 'FreeSubscription' && (
          <div className="px-2">
            <Nudges type="winners" lines={lines} />
          </div>
        )}

        <ChooseNumbers />

        {entryMethod != 'FreeSubscription' && (
          <div className="px-2">
            <Nudges type="trees" lines={lines} />
          </div>
        )}
        {entryMethod != 'FreeSubscription' && <ChooseDrawDays />}
        {entryMethod != 'FreeSubscription' &&
          chooseYourPlanVariant === 'CONTROL' && <BoostJackpotEnter />}

        <OrderSummaryMain />

        <div>
          <ContinueButtons
            onContinue={async () => {
              if (currentUser === null) {
                setPageState(PageState.AUTHENTICATION);
                await sleep(100);
                scrollToSection('#authSection');
              } else {
                if (entryMethod === EntryMethod.FreeSubscription) {
                  try {
                    const res = await handleContinueToPayment();

                    if (!res || !res.orderId) {
                      displayToast({
                        title: 'Failed to create order. Please try again.',
                        color: 'red',
                      });
                      return;
                    }

                    await updateCurrentUser();
                    await navigateToConfirmation(
                      router,
                      res.orderId,
                      false,
                      EntryMethod.FreeSubscription,
                      true,
                    );
                  } catch (err) {
                    displayToast({
                      title: `Oops, something went wrong. Please try again later.`,
                      color: '#FF6600',
                      timeout: 9000,
                    });
                  }
                } else {
                  setPageState(PageState.PAYING);
                  scrollToSection('#__next');
                }
              }
            }}
          />
        </div>

        <style jsx>{`
          .introductoryOfferBanner {
            display: none;
          }
          .big-font-desktop {
            font-size: 20px !important;
          }

          @media (min-width: 800px) {
            .introductoryOfferBanner {
              display: inline-block;
              position: absolute;
              width: 22%;
              left: 0px;
              top: 0px;
              // background: ${colors.primaryBrandGray};
              color: white;
              border-radius: 6px;
              text-transform: uppercase;
              text-align: center;
              display: visible;
            }

            .big-font-desktop {
              font-size: 30px !important;
            }
          }
        `}</style>
      </div>
    );
  },
);

export default ConfigureTicketAndSubscription;
